import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const SurveyListContainer = styled.div`
  min-height: 100%;
  position: relative;
  background: ${colors.bgScreen};
  padding: 44px 20px 15px 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const SurveyListContent = styled.div``;

export const SurveyListHeader = styled.div``;

export const SurveyListHeaderGrid = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SurveyListHeaderTitle = styled.small`
  font-size: 12px;
  color: ${colors.textSecondary};
  text-transform: uppercase;
`;

export const FadeContainer = styled.div`
  transition: ease-in-out .1s;
  opacity: ${prop => prop.fade ? '1' : '0'};
`;

export const SurveyListEmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;
`;

export const SurveyListEmptyStateParagraph = styled.p`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.bgPrimary};
  margin-top: 20px;
`;

export const SurveyButton = styled.button`
padding: 14px 32px;
box-shadow: 0px 5px 10px ${colors.shadow};
border-radius: 48px;
border: 1px solid ${colors.bgSecondaryLight};
color: ${colors.bgSecondary};
font-size: 14px;
line-height: 21px;
background: ${colors.white};
transition: ease-in-out .2s;
font-weight: 600;
letter-spacing: 0.03em;
width 90%

&:hover {
  box-shadow: 0px 5px 15px ${colors.shadowHover};
  background: ${colors.white};
  color: ${colors.textPrimary};
}
`;